import { useState, useEffect } from "react";
import HeaderDashboard from "../../Components/HeaderDashboard";
import { useLocation } from "react-router-dom";
import { GetTransactionDetails } from "../../Services/ReservationsApi"


const TransactionsDetails = () => {
  const location = useLocation();
  const [transactionDetails, setTransactionDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const queryParams = new URLSearchParams(location.search);

  function getParamIgnoreCase(key) {
    for (const [k, v] of queryParams.entries()) {
      if (k.toLowerCase() === key.toLowerCase()) {
        return v;
      }
    }
    return null;
  }

  const referenceNo = getParamIgnoreCase("ReferenceNo");
  const id = getParamIgnoreCase("Id");

  useEffect(() => {
    if (referenceNo && id) {
      fetchTransactionDetails(referenceNo, id);
    } else {
      console.warn("Missing query parameters");
    }
  }, [referenceNo, id]);

  const fetchTransactionDetails = async (referenceNo, id) => {
    try {
      setLoading(true);
      setError("");
      const params = {
        ReferenceNo: referenceNo,
        Id: id,
        ProductType: "Rail",
      };

      const response = await GetTransactionDetails(params);
      //console.log("TransactionDetails:", response);
      setTransactionDetails(response);

    } catch (err) {
      setError("Failed to load Transaction details. Please try again.");
    } finally {
      setLoading(false);
    }
  };


  return (
    <>
      {loading && (
        <p class="text-center load"><span class="loader"></span></p>
      )}
      {/* {error && <p className="text-danger">{error}</p>} */}
      <HeaderDashboard></HeaderDashboard>
      <div className="toolbar py-2" id="kt_toolbar">
        <div id="kt_toolbar_container" className="container-fluid d-flex align-items-center">
          <div className="flex-grow-1 flex-shrink-0 me-5">
            <div data-kt-swapper="true" data-kt-swapper-mode="prepend" data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}" className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
              <h1 className="d-flex align-items-center text-gray-900 fw-bold my-1 fs-3">Reservations</h1>
              <span className="h-20px border-gray-200 border-start mx-3"></span>
              <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-1">
                <li class="breadcrumb-item text-muted">Train</li>
                <li class="breadcrumb-item">
                  <span class="bullet bg-gray-200 w-5px h-2px"></span>
                </li>
                <li class="breadcrumb-item text-gray-900">Transaction Details</li>
              </ul>
            </div>
          </div>
          <div class="d-flex align-items-center flex-wrap">
            <div class="flex-shrink-0">
              <ul class="nav" role="tablist">
                <li class="nav-item" role="presentation">
                  <a href="#" onClick={(e) => { e.preventDefault(); window.history.back(); }} >
                    <img src="/assets/images/back.png" className="imgBack" />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {!loading && transactionDetails && transactionDetails.referenceNo != null ? (
        <section className="wraper">
          <div className="box_shadow mt-14">
            <h6>Booking Details</h6>

            <div className="col-md-12 mt-10 mb-5">
              <div className="row">

                <div className="col-md-4 forn_details">
                  <label>Ref No.</label>
                  <div><strong>{transactionDetails.referenceNo}</strong></div>
                </div>

                <div className="col-md-4 forn_details">
                  <label>Organization Name</label>
                  <div><strong>{transactionDetails.organizationName} ({transactionDetails.companyId})</strong></div>
                </div>

                <div className="col-md-4 forn_details">
                  <label>Travel Type</label>
                  <div><strong> {{
                    "1": "Business Travel",
                    "2": "Personal Travel",
                    "3": "Guest Travel"
                  }[transactionDetails.travelType] || "N/A"}
                  </strong></div>
                </div>

                <div className="col-md-4 forn_details">
                  <label>Name</label>
                  <div><strong>{transactionDetails.userName}</strong></div>
                </div>

                  <div className="col-md-4 forn_details">
                  <label>Phone Number</label>
                  <div><strong>{transactionDetails.phoneNumber}</strong></div>
                </div>

                <div className="col-md-4 forn_details">
                  <label>From</label>
                  <div><strong>{transactionDetails.from}</strong></div>
                </div>

                <div className="col-md-4 forn_details">
                  <label>To</label>
                  <div><strong>{transactionDetails.to}</strong></div>
                </div>

                <div className="col-md-4 forn_details">
                  <label>Travel Date</label>
                  <div><strong>{transactionDetails.travelDate}</strong></div>
                </div>

                <div className="col-md-4 forn_details">
                  <label>Class</label>
                  <div>
                    <strong>
                      {transactionDetails.class}
                    </strong>
                  </div>
                </div>
                <div className="col-md-4 forn_details">
                  <label>Quota</label>
                  <div>
                    <strong>
                      {transactionDetails.quota}
                    </strong>
                  </div>
                </div>

                <div className="col-md-4 forn_details">
                  <label>Adult</label>
                  <div><strong>{transactionDetails.noOfAdult}</strong></div>
                </div>

                <div className="col-md-4 forn_details">
                  <label>Child</label>
                  <div><strong>{transactionDetails.noOfChild}</strong></div>
                </div>

                <div className="col-md-4 forn_details">
                  <label>Infant</label>
                  <div><strong>{transactionDetails.noOfInfant}</strong></div>
                </div>

                <div className="col-md-4 forn_details">
                  <label>Status</label>
                  <div><strong>{transactionDetails.status}</strong></div>
                </div>

                <div className="col-md-4 forn_details">
                  <label>Created By</label>
                  <div><strong>{transactionDetails.createdBy}</strong></div>
                </div>

                <div className="col-md-4 forn_details">
                  <label>Created On</label>
                  <div><strong>{transactionDetails.createdOn}</strong></div>
                </div>
                {transactionDetails?.actionBy && (
                  <>
                    <div className="col-md-4 forn_details">
                      <label>Action By</label>
                      <div>
                        <strong>{transactionDetails.actionBy}</strong>
                      </div>
                    </div>

                    <div className="col-md-4 forn_details">
                      <label>Action On</label>
                      <div>
                        <strong>{transactionDetails.actionOn || "NA"}</strong>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </section>
      ) :
        (
          <section className="wraper">
            <div className="box_shadow mt-14">
              <p style={{ textAlign: "center", color: "red" }}>No data found, Plase Try with Correct Reference No.</p>
            </div>
          </section>
        )
      }
    </>
  );
};

export default TransactionsDetails;